import React, { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '../components/common/Alert';
import { setAlertMessageFunction } from '../common/Util';
import { CustomMessage } from '../components/common/Message';
import { closeCustomMsg } from '../features/common/customMsgSlice';

const AlertContext = createContext({
  alertState: {
    alerts: [],
    modal: false,
    message: {},
  },
  alertActions: {
    removeAlert: () => {},
    alertMessage: () => {},
    setModal: () => {},
    setMessage: () => {},
  },
});

const AlertProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { isOpen } = useSelector(state => state.customMsg);

  const [alerts, setAlerts] = useState([]);
  const [modal, setModal] = useState(false);
  const [message, setMessage] = useState({
    title: '확인해주세요!',
    contents: (
      <>
        입력한 내용이 저장되지 않았습니다.
        <br />
        저장하지 않고 나가시겠습니까?
      </>
    ),
    flag: '',
  });

  const removeAlert = id => {
    setAlerts(prev => prev.filter(alert => alert.id !== id));
  };

  const alertMessage = (value, variant) => {
    const newAlert = {
      id: Date.now(),
      value,
      variant,
    };
    setAlerts(prev => [...prev, newAlert]);
  };

  useEffect(() => {
    setAlertMessageFunction(alertMessage);
  }, []);

  const value = {
    alertState: { alerts, modal, message },
    alertActions: {
      removeAlert,
      alertMessage,
      setModal,
      setMessage,
    },
  };

  return (
    <AlertContext.Provider value={value}>
      {children}
      {alerts.map((alert, index) => (
        <Alert key={alert.id} alert={alert} index={index} />
      ))}
      {isOpen && <CustomMessage closeMsg={() => dispatch(closeCustomMsg())} />}
    </AlertContext.Provider>
  );
};

export { AlertProvider };

export default AlertContext;
